import { registerPlugin } from '@capacitor/core';
const PianoDmp = registerPlugin('PianoDmp', {
    web: () => import('./web').then(m => new m.PianoDmpWeb()),
});
export * from './definitions';
export { PianoDmp };
//# sourceMappingURL=index.js.map